// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React, { useEffect, useRef } from 'react';
import { useActor } from '@xstate/react';

import {
  CANCELLED_TO_CHOOSE_FILE,
  CHOOSE_FILE_CLICKED,
  FAILED,
  FileUploaderMachineActor,
  LOADING,
  SUCCESS,
  SUCCESSFULLY_UPLOADED_STATE,
  UPLOAD_FILE_CLICKED,
  UPLOAD_TO_AWS
} from '../../../../data-access/src';

import { AssetUploaderComponent } from '../AssetUploaderComponent';
import { Loader } from '../Loader';
import { UploadedImageComponent } from '../UploadedImageComponent';

import {
  FileInput,
  FileUploaderContainer,
  LoaderContaner
} from './styledComponent';

export interface FileUploaderPropTypes {
  fileUploaderInfo: FileUploaderMachineActor;
  onSuccessFileUpload?: (url: string) => void;
  isNotValid?: boolean;
  overrideBucketPath?: string;
  extraBucketPath?: string;
  getCustomFileName?: Function;
  onDeleteSuccess?: Function;
  defaultValue?: string;
  selectedFileName?: string;
  value?: string;
  isDisabled?: boolean;
  shouldShowDeleteButton?: boolean;
}

export const FileUploader = (props: FileUploaderPropTypes) => {
  const [fileUploaderState, fileUploaderSend] = useActor(
    props.fileUploaderInfo
  );

  const {
    onSuccessFileUpload,
    value,
    extraBucketPath,
    getCustomFileName,
    onDeleteSuccess,
    defaultValue,
    selectedFileName,
    isDisabled,
    shouldShowDeleteButton
  } = props;

  useEffect(() => {
    if (fileUploaderState.matches(SUCCESSFULLY_UPLOADED_STATE)) {
      const { selectedFileDetails } = fileUploaderState.context;
      if (selectedFileDetails.name) {
        const url = decodeURIComponent(
          fileUploaderState?.context?.s3UploadedFileInfo.Location
        );
        onSuccessFileUpload && onSuccessFileUpload(url);
      }
    }
  }, [fileUploaderState]);

  const inputRef =
    useRef<HTMLInputElement>() as React.MutableRefObject<HTMLInputElement>;

  const checkIt = () => {
    const selectedImages = inputRef.current.files;
    if (selectedImages && selectedImages.length > 0) {
      fileUploaderSend({
        type: UPLOAD_FILE_CLICKED,
        imgDetails: selectedImages[0],
        overrideBucketPath: '',
        getCustomFileName: getCustomFileName
      });
    } else {
      fileUploaderSend({ type: CANCELLED_TO_CHOOSE_FILE });
    }
    document.body.onfocus = null;
  };

  const onClickUploadFile = () => {
    inputRef.current.click();
  };

  const onClick = () => {
    fileUploaderSend({ type: CHOOSE_FILE_CLICKED });
    checkIt();
  };

  const getFileName = (name) => {
    if (name) {
      return name;
    }
  };

  const getFileExtension = (name) => {
    if (name) {
      return name.split('.')[1];
    }
  };

  const getImageLocation = () => {
    const { selectedFileDetails } = fileUploaderState.context;
    if (selectedFileDetails.name) {
      const url = URL.createObjectURL(selectedFileDetails);
      return url;
    }
    return '';
  };

  const onClickDeleteButton = () => {
    if (!isDisabled) {
      fileUploaderSend({
        type: 'DELETE_FILE'
      });
      onDeleteSuccess && onDeleteSuccess();
      inputRef.current.value = '';
    }
  };

  const onRetryUpload = () => {
    fileUploaderSend({ type: UPLOAD_TO_AWS });
  };
  const getImageURLFromExistingValue = (value: string) => {
    if (!value) return '';
    const nameArray = value.split('/');
    return nameArray[nameArray.length - 1];
  };

  const isUploadFailed = fileUploaderState.hasTag(FAILED);
  return (
    <FileUploaderContainer isDisabled={isDisabled}>
      {fileUploaderState.hasTag(SUCCESS) ||
      isUploadFailed ||
      defaultValue ||
      value ? (
        <UploadedImageComponent
          imageUrl={getImageLocation()}
          fileName={
            getFileName(fileUploaderState.context.selectedFileDetails.name) ||
            selectedFileName ||
            getImageURLFromExistingValue(value)
          }
          uploadFileFunction={onClickUploadFile}
          fileUploaderSend={fileUploaderSend}
          extraBucketPath={extraBucketPath}
          fileExtension={getFileExtension(
            fileUploaderState.context.selectedFileDetails.name
          )}
          onClickDeleteButton={onClickDeleteButton}
          isUploadFailed={isUploadFailed}
          onRetryUpload={onRetryUpload}
          shouldShowDeleteButton={shouldShowDeleteButton}
          isDisabled={isDisabled}
        />
      ) : fileUploaderState.hasTag(LOADING) ? (
        <LoaderContaner>
          <Loader />
        </LoaderContaner>
      ) : (
        <AssetUploaderComponent
          uploadFileFunction={onClickUploadFile}
          fileUploaderSend={fileUploaderSend}
          isNotValid={props.isNotValid}
        />
      )}
      <FileInput
        type="file"
        ref={inputRef}
        onChange={(e) => {
          onClick();
        }}
        accept={
          fileUploaderState.context.fileUploadDetails
            ? fileUploaderState.context.fileUploadDetails.fileAcceptTypes
            : ''
        }
      />
    </FileUploaderContainer>
  );
};
